/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkerSources } from './worker-sources';


export interface WorkerByIdResponse { 
    id: string;
    name: string;
    displayName: string;
    clientId?: string | null;
    clientName?: string | null;
    statusId: number;
    poolId: string;
    coinId: number;
    observerLink?: string | null;
    source: WorkerSources;
    isEditable: boolean;
}



